import ChatMediaMessage from './ChatMediaMessage';
import { useTravelText } from '../../../app/TravelLocaleContext';
import SafeImage from '../../../components/SafeImage';
import { resolveChatImageSrc } from '../travelChatImageModel';
import ActivityCardMessage from './ActivityCardMessage';
import BalanceCardMessage from './BalanceCardMessage';
import DecisionCardMessage from './DecisionCardMessage';
import ExpenseCardMessage from './ExpenseCardMessage';
import MemoryCardMessage from './MemoryCardMessage';
import SituationCardMessage from './SituationCardMessage';
import JourneyPublicationCardMessage from './JourneyPublicationCardMessage';
import { JOURNEY_PUBLICATION, journeyPublicationIdOf } from '../journeyPublicationCardModel';
import {
  ACTIVITY_RENDERER_KEY,
  BALANCE_RENDERER_KEY,
  BUSINESS_CARD,
  DECISION_CARD,
  EXPENSE_RENDERER_KEY,
  MEMORY_RENDERER_KEY,
  SITUATION_CARD,
  cardFallbackText,
} from './travelCardModel';


export default function TravelMessageContent({ message, journeyPublicationResolution, onRetryJourneyPublication }) {
  const { t } = useTravelText();
  const type = String(message?.messageType || 'TEXT');
  if (message?.status === 'REVOKED' || message?.revokedAt) {
    return <p role="status">{t('travel.chat.revoked')}</p>;
  }
  if (['STICKER', 'GIF', 'VIDEO', 'FILE'].includes(type)) return <ChatMediaMessage message={message} />;
  if (type === 'TEXT') {
    return <p>{message?.text || ''}</p>;
  }
  if (type === 'IMAGE') {
    const src = resolveChatImageSrc(message);
    if (!src) {
      return <p>{message?.text || t('travel.chat.fallbackImage')}</p>;
    }
    return (
      <figure className="travel-msg-image">
        <a className="travel-msg-image__link" href={src} target="_blank" rel="noopener noreferrer">
          <SafeImage
            className="travel-msg-image__img"
            src={src}
            alt={message.fileName || message.text || t('travel.chat.imageButton')}
            fallback={<span className="travel-msg-image__failed">{t('travel.chat.mediaFailed')}</span>}
          />
        </a>
        {message?.text ? <figcaption>{message.text}</figcaption> : null}
      </figure>
    );
  }
  if (type === DECISION_CARD) {
    return <DecisionCardMessage message={message} />;
  }
  if (type === SITUATION_CARD) {
    return <SituationCardMessage message={message} />;
  }
  if (type === BUSINESS_CARD) {
    const rendererKey = String(message?.businessCard?.rendererKey || '');
    if (rendererKey === ACTIVITY_RENDERER_KEY) {
      return <ActivityCardMessage message={message} />;
    }
    if (rendererKey === MEMORY_RENDERER_KEY) {
      return <MemoryCardMessage message={message} />;
    }
    if (rendererKey === EXPENSE_RENDERER_KEY) {
      return <ExpenseCardMessage message={message} />;
    }
    if (rendererKey === BALANCE_RENDERER_KEY) {
      return <BalanceCardMessage message={message} />;
    }
    return <p>{cardFallbackText(message, t('travel.chat.unsupportedCard'))}</p>;
  }
  if (type === JOURNEY_PUBLICATION) {
    return (
      <JourneyPublicationCardMessage
        publicationId={journeyPublicationIdOf(message)}
        resolution={journeyPublicationResolution}
        note={message?.text}
        onRetry={onRetryJourneyPublication}
      />
    );
  }
  return <p>{message?.text || t('travel.chat.fallbackMessage')}</p>;
}
